import { Component, OnInit } from '@angular/core';

import { environment } from '../../environments/environment';

import { faCheck, faXmark, faWhatsapp, faTriangleExclamation, faCircleCheck, faStar } from '../icons';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  faCheck = faCheck;
  faXmark = faXmark;
  faWhatsapp = faWhatsapp;
  faTriangleExclamation = faTriangleExclamation;
  faCircleCheck = faCircleCheck;
  faStar = faStar;

  currentYear = new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
  }

  // The server recognizes this message (and the plan) to alert the sales team
  goToWhatsapp(plan?: string) {
    let msg = "Olá, eu gostaria de saber mais sobre o NCommerce!";
    if (plan) {
      msg += ` Tenho interesse no Plano ${plan}.`;
    }
    let link = `https://wa.me/${environment.ncommerce_wapp}?text=${encodeURIComponent(msg)}`;
    window.open(link, "_blank");
  }
}
